export default "__VITE_ASSET__B9YlJs8d__"